import React from "react";
import { Collapse,Badge } from "antd";
import ExpertQA from './ExpertQA/index';
import DocQA from './docQA/index';
import GenAiAnswerComponent from "../../Component/GenAiAnswerComponent/GenAiAnswerComponent";
import { useSelector } from "react-redux";
import NewGenAiAnswerComponent from "./NewGenAIComponent";
import { getExpertsProfilePics } from "../../API/api";
const { Panel } = Collapse;
// The dataMap structure
const textStyles = {
    fontSize: "18px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
    flex: 1, 
    marginRight: "10px", 
    overflow: "hidden", 
    textOverflow: "ellipsis",
    flexWrap:"wrap" 
  };
const GenSummaryDeclined = ({ dataMap,uuid }) => {
   
    // React.useEffect(()=>{
    //     if(uuid.length>0){
    //         getExpertsProfilePics(uuid, undefined);
    //     }
    // },[])
    // Convert Map to an array of panels
    const editorState = useSelector(state=>state.editor);
    const panels = Array.from(dataMap).map(([key, value]) => {
        // console.log("values",value[0])
        const firstQuestion = value[0]?.origQuery!==undefined?value[0]?.origQuery: value[0]?.question!==undefined? value[0]?.question:"No question available";
        // const genAi = value[0]?.summarisedText || "No GenAi Summary available";
        const genAi= value.find(item => item.summarisedText)?.summarisedText || "No GenAi Summary available";
         
        const firstAnswer =value[0]?.answers[0]?.answerText || "No answer available";
        const length = value.length;
     
        const Header = () => {
            return <>
            
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                   
                    <div>
                    <span style={textStyles}>
                        {firstQuestion}
                    </span>
                    {/* <span style={textStyles}>
                    {firstQuestion}
                    </span> */}
                    </div>
                   <div>
                     <Badge
                        count={length}
                        style={{
                            backgroundColor: "#55C1FA", 
                            borderRadius: "50%",    
                            width: "22px",          
                            height: "22px",        
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "12px",       
                            marginLeft:"5px"   // Adjust font size
                        }}
                    />
                   </div>
                   
                </div>
            </>
        }
        // console.log("value",value)
        return (
            <Panel
                // header={`${firstQuestion} (Total: ${length})`}
                header={<Header />}
                key={key}
            >
                <div>
                    <div>     
                         {<NewGenAiAnswerComponent data={genAi} />} 
                    </div>
                    <div style={{paddingTop:"15px"}}>
                        {value&& value.map(qa=>{
                                //   console.log('render',qa.docType)
                                  // data, question
                                  return(
                                    <React.Fragment key={qa.questionUuid}>
                                        {/* {
                                            qa?.docType==="Pdf"  && <DocQA data={qa} answers={qa.answers}/>
                                        } */}
                                    {
                                      qa?.docType!=="expertqa"  && <DocQA data={qa} answers={qa.answers}/>
                                     
                                    }
                                    {qa?.docType==="expertqa"&& <ExpertQA data={qa} tab={2} fav={false} answers={qa.answers} question={value}/>}
                                      {/* <NewQuestionBox data={qa}/>  */}
                                    </React.Fragment>
                                  )
                                })}  
                      
                    </div>
                </div>
            </Panel>
        );
    });
    return (
        <div >
          
            <Collapse accordion expandIconPosition="end">
                {panels}
            </Collapse>
        </div>
    );
};
export default GenSummaryDeclined;




